import AuthService from '../services/auth.service';
import RoleService from '../services/role.service';
import PreferencesService from '../services/preferences.service';

const user = JSON.parse(localStorage.getItem('user'));
const roles = JSON.parse(localStorage.getItem('roles'));
const preferences = JSON.parse(localStorage.getItem('preferences'));

const initialState = {
	status: {
		loggedIn: user ? true : false,
	},
	user: user ? user : null,
	roles: roles ? roles : null,
	preferences: preferences ? preferences : null,
};

export const auth = {
	namespaced: true,
	state: initialState,
	actions: {
		login({commit}, user) {
			return AuthService.login(user).then(
				(user) => {
					commit('loginSuccess', user);
					return Promise.resolve(user);
				},
				(error) => {
					commit('loginFailure');
					return Promise.reject(error);
				}
			);
		},
		fetchRoles({commit}) {
			return RoleService.getAll().then(
				(response) => {
					commit('fetchRolesSuccess', response);
					return Promise.resolve(roles);
				},
				(error) => {
					commit('fetchRolesFailure');
					return Promise.reject(error);
				}
			);
		},
		fetchPreferences({commit}) {
			return PreferencesService.get(this.state.auth.user.token).then(
				(response) => {
					commit('fetchPreferencesSuccess', response);
					return Promise.resolve(preferences);
				},
				(error) => {
					commit('fetchPreferencesFailure');
					return Promise.reject(error);
				}
			);
		},
		logout({commit}) {
			AuthService.logout();
			commit('logout');
		},
	},
	mutations: {
		loginSuccess(state, user) {
			state.status.loggedIn = true;
			state.user = user;
		},
		loginFailure(state) {
			state.status.loggedIn = false;
			state.user = null;
		},
		fetchRolesSuccess(state, response) {
			if (response.data.roles) {
				localStorage.setItem('roles', JSON.stringify(response.data.roles));
				state.roles = response.data.roles;
			}
		},
		fetchRolesFailure(state) {
			state.roles = null;
		},
		fetchPreferencesSuccess(state, response) {
			if (response.data.preferences) {
				localStorage.setItem('preferences', response.data.preferences);
				state.preferences = response.data.preferences;
			}
		},
		fetchPreferencesFailure(state) {
			state.preferences = null;
		},
		logout(state) {
			state.status.loggedIn = false;
			localStorage.removeItem('roles');
			localStorage.removeItem('preferences');
			localStorage.removeItem('typo3versions');
			state.roles = null;
			state.user = null;
			state.preferences = null;
			state.typo3versions = null;
		},
	},
};
